import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Wrapper from '../../components/wrapper'
import { WINDOW, DOCUMENT, IS_ANDROID } from '../../constants/environment'
import './styles.css'

import DealerIconDark from './icon_dealer_dark.png'
import DealerIconLight from './icon_dealer_light.png'
import TestdriveIconDark from './icon_testdrive_dark.png'
import TestdriveIconLight from './icon_testdrive_light.png'
import EstimateIconDark from './icon_estimate_dark.png'
import EstimateIconLight from './icon_estimate_light.png'
import CatalogIconDark from './icon_catalog_dark.png'
import CatalogIconLight from './icon_catalog_light.png'
import CarsComparisonIconDark from './icon_cars-comparison_dark.png'
import CarsComparisonIconLight from './icon_cars-comparison_light.png'

/**
 *  Cta
 */
class Cta extends PureComponent {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    ctaType: PropTypes.string,
    href: PropTypes.string,
    text: PropTypes.string,
    targetBlank: PropTypes.bool,
    linkType: PropTypes.string,
    iconSrc: PropTypes.string,
    hoverIconSrc: PropTypes.string,
    color: PropTypes.string,
    buttonStyle: PropTypes.string,
    additionalClass: PropTypes.string,
    urlParams: PropTypes.shape({
      testdrive: PropTypes.string,
      estimate: PropTypes.string,
      catalog: PropTypes.string,
      comparison: PropTypes.string
    }),
    handleClick: PropTypes.func,
    buttonLength: PropTypes.number,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    ctaType: null,
    href: null,
    text: null,
    targetBlank: null,
    linkType: null,
    iconSrc: null,
    hoverIconSrc: null,
    color: null,
    buttonStyle: null,
    additionalClass: null,
    urlParams: null,
    handleClick: null,
    buttonLength: null,
  };

  constructor(props) {
    super()
    this.props = props
  }

  componentDidMount() {
    // WINDOW.MZD_CARINFO_SETTINGS = [
    //   {
    //     BodyTypeModel: 'MAZDA2', VehicleType: 'PassengerCar', CarNavigationNumber: '1', ModelName: 'mazda2', CarId: 'mazda2', CarTypeCode: 'DJ1'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA3 FASTBACK', VehicleType: 'PassengerCar', CarNavigationNumber: '2', ModelName: 'mazda3', CarId: 'mazda3-fastback', CarTypeCode: 'BP2'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA3 SEDAN', VehicleType: 'PassengerCar', CarNavigationNumber: '3', ModelName: 'mazda3', CarId: 'mazda3-sedan', CarTypeCode: 'BP1'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA6 SEDAN', VehicleType: 'PassengerCar', CarNavigationNumber: '4', ModelName: 'mazda6', CarId: 'mazda6-sedan', CarTypeCode: 'AS1'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA6 WAGON', VehicleType: 'PassengerCar', CarNavigationNumber: '5', ModelName: 'mazda6', CarId: 'mazda6-wagon', CarTypeCode: 'AW2'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA CX-3', VehicleType: 'PassengerCar', CarNavigationNumber: '6', ModelName: 'cx-3', CarId: 'cx-3', CarTypeCode: 'DK4'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA CX-5', VehicleType: 'PassengerCar', CarNavigationNumber: '7', ModelName: 'cx-5', CarId: 'cx-5', CarTypeCode: 'KF4'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA CX-8', VehicleType: 'PassengerCar', CarNavigationNumber: '8', ModelName: 'cx-8', CarId: 'cx-8', CarTypeCode: 'GK2'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA ROADSTER', VehicleType: 'PassengerCar', CarNavigationNumber: '9', ModelName: 'roadster', CarId: 'roadster', CarTypeCode: 'RS2'
    //   },
    //   {
    //     BodyTypeModel: 'MAZDA ROADSTER RF', VehicleType: 'PassengerCar', CarNavigationNumber: '10', ModelName: 'roadsterrf', CarId: 'roadsterrf', CarTypeCode: 'RF2'
    //   },
    //   {
    //     BodyTypeModel: 'FLAIR', VehicleType: 'LightCar', CarNavigationNumber: '1', ModelName: 'flair', CarId: 'flair', CarTypeCode: 'MJ6'
    //   },
    //   {
    //     BodyTypeModel: 'FLAIR WAGON', VehicleType: 'LightCar', CarNavigationNumber: '2', ModelName: 'flair-wagon', CarId: 'flair-wagon', CarTypeCode: 'MM6'
    //   },
    //   {
    //     BodyTypeModel: 'FLAIR CROSSOVER', VehicleType: 'LightCar', CarNavigationNumber: '3', ModelName: 'flair-crossover', CarId: 'flair-crossover', CarTypeCode: 'ZK4'
    //   },
    //   {
    //     BodyTypeModel: 'CAROL', VehicleType: 'LightCar', CarNavigationNumber: '4', ModelName: 'carol', CarId: 'carol', CarTypeCode: 'HB1'
    //   },
    //   {
    //     BodyTypeModel: 'SCRUM WAGON', VehicleType: 'LightCar', CarNavigationNumber: '5', ModelName: 'scrum-wagon', CarId: 'scrum-wagon', CarTypeCode: 'DG2'
    //   }
    // ]

    let href = null

    const query_car_id = this.getQuery('car_id')

    let cookie_car_id = this.getCookie('mjcarid')

    // console.log('query_car_id', query_car_id);
    // console.log('cookie_car_id', cookie_car_id);

    // axelaかatenzaのとき、この単語がmjcaridに含まれていなければ、Cookieを見ない
    if (WINDOW) {
      const pathname = WINDOW.location.pathname // ex: '/cars/atenza/safety/'
      const result = pathname.match(/\/cars\/(axela|atenza)\//)
      if (result != null && cookie_car_id !== false && cookie_car_id.indexOf(result[1]) === -1) {
        cookie_car_id = false
      }
    }

    // let car_id = query_car_id || (cookie_car_id || '')

    let car_id = this.getCarIdForAkamai(query_car_id, cookie_car_id)

    switch (this.props.ctaType) {
      case 'Testdrive':
        car_id = car_id !== '' ? car_id : (this.props.urlParams.testdrive && this.props.urlParams.testdrive !== '') ? this.props.urlParams.testdrive : ''
        href = '/purchase/testdrive/'
        href += car_id !== '' ? ('?car_id=' + car_id) : ''
        this.refs.link.href = href
        break
      case 'Estimate':
        car_id = car_id !== '' ? car_id : (this.props.urlParams.estimate && this.props.urlParams.estimate !== '') ? this.props.urlParams.estimate : ''
        // href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/estimate/': 'https://ssl.mazda.co.jp/purchase/estimate/';
        // href += car_id !== '' ? ('edit.html?car_id=' + car_id) : '';
        href = 'https://www.mazda.co.jp/purchase/estimate/'
        href += car_id !== '' ? ('?car_id=' + car_id) : ''
        this.refs.link.href = href
        break
      case 'Catalog':
        car_id = (this.props.urlParams.catalog && this.props.urlParams.catalog !== '') ? this.props.urlParams.catalog : ''
        // href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/catalog/': 'https://ssl.mazda.co.jp/purchase/catalog/';
        href = 'https://my.mazda.co.jp/purchase/catalog/'
        href += car_id !== '' ? car_id : 'index.html'
        this.refs.link.href = href
        break
      case 'Cars-Comparison':
        car_id = car_id !== '' ? car_id : (this.props.urlParams.comparison && this.props.urlParams.comparison !== '') ? this.props.urlParams.comparison : ''
        href = '/purchase/compare/'
        href += car_id !== '' ? ('?car_id1=' + car_id) : ''
        this.refs.link.href = href
        break
      default:
    }
  }

  componentWillUnmount() {
  }

  getCookie = (key) => {
    if (!DOCUMENT || !DOCUMENT.cookie) {
      return false
    }
    const cookies = DOCUMENT.cookie.split(';')
    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i].split('=')
      if (cookie[0].trim() === key) {
        return cookie[1].trim()
      }
    }

    return false
  };

  getQuery = (key) => {
    if (!WINDOW || !WINDOW.location) {
      return false
    }
    const params = WINDOW.location.search.substring(1).split('&')
    for (let i = 0; i < params.length; i += 1) {
      const param = params[i].split('=')
      if (param[0].trim() === key) {
        return param[1].trim()
      }
    }
    return false
  };

  // Akamai対応のためのロジック改修
  // return '' したものは car_id のデフォルト値が適用される
  getCarIdForAkamai = (queryCarId, cookieCarId) => {
    if (
      !WINDOW ||
      !WINDOW.MZD_CARINFO_SETTINGS ||
      !Array.isArray(WINDOW.MZD_CARINFO_SETTINGS) ||
      WINDOW.MZD_CARINFO_SETTINGS.length === 0
    ) {
      return ''
    }

    const pathname = WINDOW.location.pathname
    const result = pathname.match(/\/cars\/(.+?)\//)
    const modelname = result ? result[1] : ''
    const resultRoadsterRf = pathname.match(/\/cars\/(roadster-rf)\//)

    // URL の Modelname が「roadster-rf」の場合
    if (resultRoadsterRf != null) {
      return ''
    }

    // MZD_CARINFO_SETTINGS の Modelname と CarId が一致する場合
    for (let i = 0; i < WINDOW.MZD_CARINFO_SETTINGS.length; i += 1) {
      const setting = WINDOW.MZD_CARINFO_SETTINGS[i]
      if (setting.ModelName === modelname && setting.ModelName === setting.CarId) {
        return ''
      }
    }

    // URL の 「car_id=xxx」が付与されている場合
    if (queryCarId) {
      return queryCarId
    }

    // coookieにmjcaridが存在しない場合
    if (!cookieCarId) {
      return ''
    }

    // MZD_CARINFO_SETTINGS の CarId と mjcarid が合致する場合
    for (let i = 0; i < WINDOW.MZD_CARINFO_SETTINGS.length; i += 1) {
      const setting = WINDOW.MZD_CARINFO_SETTINGS[i]
      if (setting.ModelName === modelname && setting.CarId === cookieCarId) {
        return cookieCarId
      }
    }

    return ''
  };

  render() {
    const {
      containerId,
      containerClass,
      ctaType,
      href,
      text,
      targetBlank,
      linkType,
      iconSrc,
      hoverIconSrc,
      color,
      buttonStyle,
      additionalClass,
      urlParams,
      handleClick,
      buttonLength,
    } = this.props

    let new_href
    let new_text
    let new_icon
    let new_icon_hover

    switch (ctaType) {
      case 'Dealer':
        new_href = 'http://www.mazda.co.jp/purchase/dealer/'
        new_text = '販売店検索'
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = DealerIconDark
              new_icon_hover = DealerIconDark
            } else {
              new_icon = DealerIconLight
              new_icon_hover = DealerIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = DealerIconLight
            new_icon_hover = DealerIconLight
          } else {
            new_icon = DealerIconDark
            new_icon_hover = DealerIconLight
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = DealerIconLight
              new_icon_hover = DealerIconLight
            } else {
              new_icon = DealerIconDark
              new_icon_hover = DealerIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = DealerIconLight
            new_icon_hover = DealerIconLight
          } else {
            new_icon = DealerIconLight
            new_icon_hover = DealerIconDark
          }
        }
        break
      case 'Testdrive':
        new_href = '/purchase/testdrive/'
        new_href += (urlParams.testdrive && urlParams.testdrive !== '') ? '?car_id=' + urlParams.testdrive : ''
        new_text = '試乗車検索'
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = TestdriveIconDark
              new_icon_hover = TestdriveIconDark
            } else {
              new_icon = TestdriveIconLight
              new_icon_hover = TestdriveIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = TestdriveIconLight
            new_icon_hover = TestdriveIconLight
          } else {
            new_icon = TestdriveIconDark
            new_icon_hover = TestdriveIconLight
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = TestdriveIconLight
              new_icon_hover = TestdriveIconLight
            } else {
              new_icon = TestdriveIconDark
              new_icon_hover = TestdriveIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = TestdriveIconLight
            new_icon_hover = TestdriveIconLight
          } else {
            new_icon = TestdriveIconLight
            new_icon_hover = TestdriveIconDark
          }
        }
        break
      case 'Estimate':
        new_href = 'https://ssl.mazda.co.jp/purchase/estimate/'
        new_href += (urlParams.estimate && urlParams.estimate !== '') ? 'edit.html?car_id=' + urlParams.estimate : ''
        new_text = 'カンタン見積り'
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = EstimateIconDark
              new_icon_hover = EstimateIconDark
            } else {
              new_icon = EstimateIconLight
              new_icon_hover = EstimateIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = EstimateIconLight
            new_icon_hover = EstimateIconLight
          } else {
            new_icon = EstimateIconDark
            new_icon_hover = EstimateIconLight
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = EstimateIconLight
              new_icon_hover = EstimateIconLight
            } else {
              new_icon = EstimateIconDark
              new_icon_hover = EstimateIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = EstimateIconLight
            new_icon_hover = EstimateIconLight
          } else {
            new_icon = EstimateIconLight
            new_icon_hover = EstimateIconDark
          }
        }
        break
      case 'Catalog':
        new_href = 'https://ssl.mazda.co.jp/purchase/catalog/'
        new_href += (urlParams.catalog && urlParams.catalog !== '') ? urlParams.catalog : ''
        new_text = 'カタログ請求'
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = CatalogIconDark
              new_icon_hover = CatalogIconDark
            } else {
              new_icon = CatalogIconLight
              new_icon_hover = CatalogIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = CatalogIconLight
            new_icon_hover = CatalogIconLight
          } else {
            new_icon = CatalogIconDark
            new_icon_hover = CatalogIconLight
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = CatalogIconLight
              new_icon_hover = CatalogIconLight
            } else {
              new_icon = CatalogIconDark
              new_icon_hover = CatalogIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = CatalogIconLight
            new_icon_hover = CatalogIconLight
          } else {
            new_icon = CatalogIconLight
            new_icon_hover = CatalogIconDark
          }
        }
        break
      case 'Cars-Comparison':
        new_href = '/purchase/compare/'
        new_text = '車種比較'
        if (color === 'Dark') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = CarsComparisonIconDark
              new_icon_hover = CarsComparisonIconDark
            } else {
              new_icon = CarsComparisonIconLight
              new_icon_hover = CarsComparisonIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = CarsComparisonIconLight
            new_icon_hover = CarsComparisonIconLight
          } else {
            new_icon = CarsComparisonIconDark
            new_icon_hover = CarsComparisonIconLight
          }
        } else if (color === 'Light') {
          if (buttonStyle === 'Action') {
            if (linkType === 'Text-With-Icon') {
              new_icon = CarsComparisonIconLight
              new_icon_hover = CarsComparisonIconLight
            } else {
              new_icon = CarsComparisonIconDark
              new_icon_hover = CarsComparisonIconLight
            }
          } else if (buttonStyle === 'CTA-Navi') {
            new_icon = CarsComparisonIconLight
            new_icon_hover = CarsComparisonIconLight
          } else {
            new_icon = CarsComparisonIconLight
            new_icon_hover = CarsComparisonIconDark
          }
        }
        break
      default:
        new_href = (href && href !== '') ? href : ''
        new_text = (text && text !== '') ? text : ''
        new_icon = (iconSrc && iconSrc !== '') ? iconSrc : ''
        new_icon_hover = (hoverIconSrc && hoverIconSrc !== '') ? hoverIconSrc : ''
    }

    const cta_container_attrs = {
      className: [
        'Cta__container',
        (color && color !== '') ? 'Cta__container--' + color : null
      ].join(' ')
    }

    // const cta_button_attrs = {
    //   href: new_href,
    //   target: (targetBlank && targetBlank !== '' && targetBlank === true) ? '_blank': '',
    //   className: [
    //     'Cta__button',
    //     (linkType && linkType !== '') ? 'Cta__button--linkType--' + linkType: null,
    //     (buttonStyle && buttonStyle !== '') ? 'Cta__button--buttonStyle--' + buttonStyle: null,
    //     (additionalClass && additionalClass !== '') ? additionalClass: null,
    //   ].join(' '),
    // };
    //

    let props = null
    if (handleClick !== null) {
      new_href = 'javascript:void(0)'
      props = {
        onClick: (e) => {
          e.preventDefault()
          handleClick(e)
        }
      }
    }

    const renderText = ()=> {

      let cls = '';
      if (IS_ANDROID) {
        cls = ' isAndroid';
      }

      if (buttonStyle === 'CTA-Navi') {
        if (0 <= new_text.indexOf('|')) {
          if (WINDOW) {
            if (WINDOW.matchMedia('(max-width: 767px)').matches) {
              new_text = new_text.replace('|', '<br />')
              return (
                (new_text && new_text !== '') ? <span className={'Cta__button__text' + cls} dangerouslySetInnerHTML={{__html: new_text}}/> : ''
              )
            } else {
              new_text = new_text.replace('|', '')
              return (
                (new_text && new_text !== '') ? <span className={'Cta__button__text' + cls}>{new_text}</span> : ''
              )
            }
          }
        } else {
          if (WINDOW) {
            if (WINDOW.matchMedia('(max-width: 320px)').matches) {
              if ((3 === buttonLength || 5 <= buttonLength) && 7 <= new_text.length) {
                return (
                  (new_text && new_text !== '') ? <span className={'Cta__button__text' + cls} style={{letterSpacing: '-0.1em'}}>{new_text}</span> : ''
                )
              }
            }
          }
        }
      }

      // if (buttonStyle === 'CTA-Navi' && 0 <= new_text.indexOf('|')) {
      //   if (WINDOW) {
      //     if (WINDOW && WINDOW.matchMedia('(max-width: 767px)').matches) {
      //       new_text = new_text.replace('|', '<br />')
      //       return (
      //         (new_text && new_text !== '') ? <span className="Cta__button__text" dangerouslySetInnerHTML={{__html: new_text}} /> : ''
      //       )
      //     } else {
      //       new_text = new_text.replace('|', '')
      //       return (
      //         (new_text && new_text !== '') ? <span className="Cta__button__text">{new_text}</span> : ''
      //       )
      //     }
      //   }
      // }

      new_text = new_text.replace('|', '')
      return (
        (new_text && new_text !== '') ? <span className={'Cta__button__text' + cls}>{new_text}</span> : ''
      )
    }

    const renderIcon = ()=> {
      if (linkType === 'Button-With-Icon' || linkType === 'Text-With-Icon' || buttonStyle === 'CTA-Navi') {
        // const iconStyle = { backgroundImage: 'url(' + new_icon + ')' }
        // const iconStyleHover = { backgroundImage: 'url(' + new_icon_hover + ')' }
        return (
          <span className="Cta__button__icon__container">
            {new_icon && new_icon !== '' ? <img src={new_icon} className="Cta__button__icon" /> : null}
            {new_icon_hover && new_icon_hover !== '' ? <img src={new_icon_hover} className="Cta__button__icon--hover" /> : null}
          </span>
        )
      }
      return null;
    }

    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}>
        <div className="Cta">
          <div {...cta_container_attrs}>
            <a
              {...props}
              ref="link"
              href={new_href}
              target={(targetBlank && targetBlank !== '' && targetBlank === true) ? '_blank' : ''}
              className={(() => (
                [
                  'Cta__button',
                  (linkType && linkType !== '') ? 'Cta__button--linkType--' + linkType : null,
                  (buttonStyle && buttonStyle !== '') ? 'Cta__button--buttonStyle--' + buttonStyle : null,
                  (additionalClass && additionalClass !== '') ? additionalClass : null,
                  (()=> {
                    if (5 <= buttonLength) {
                      return 'Cta__button--buttonLength--5';
                    } else if (1 <= buttonLength) {
                      return 'Cta__button--buttonLength--' + buttonLength;
                    }
                    return null;
                  })()
                ].join(' ')
              ))()}>
              {(()=> {
                if (WINDOW) {
                  if (WINDOW.matchMedia('(max-width: 767px)').matches) {
                    if (buttonStyle === 'CTA-Navi') {
                      if (4 <= buttonLength) {
                        return (
                          <div className="Cta__button__container">
                            {renderIcon()}
                            {renderText()}
                          </div>
                        )
                      } else {
                        return (
                          <div className="Cta__button__container">
                            {renderText()}
                            {renderIcon()}
                          </div>
                        )
                      }
                    } else {
                      return (
                        <React.Fragment>
                          {renderText()}
                          {renderIcon()}
                        </React.Fragment>
                      )
                    }
                  }
                }
                return (
                  <React.Fragment>
                    {renderText()}
                    {renderIcon()}
                  </React.Fragment>
                )
              })()}
              {/*{(new_text && new_text !== '') ? <span className="Cta__button__text">{new_text}</span> : ''}*/}
              {/*{(() => {*/}
              {/*  if (linkType === 'Button-With-Icon' || linkType === 'Text-With-Icon' || buttonStyle === 'CTA-Navi') {*/}
              {/*    const iconStyle = { backgroundImage: 'url(' + new_icon + ')' }*/}
              {/*    const iconStyleHover = { backgroundImage: 'url(' + new_icon_hover + ')' }*/}
              {/*    return (*/}
              {/*      <span className="Cta__button__icon__container">*/}
              {/*        {new_icon && new_icon !== '' ? <img src={new_icon} className="Cta__button__icon" /> : null}*/}
              {/*        {new_icon_hover && new_icon_hover !== '' ? <img src={new_icon_hover} className="Cta__button__icon--hover" /> : null}*/}
              {/*      </span>*/}
              {/*    )*/}
              {/*  }*/}
              {/*})()}*/}
            </a>
          </div>
        </div>
      </Wrapper>
    )
  }
}

export default Cta



// WEBPACK FOOTER //
// ./src/containers/cta/index.jsx